import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  CONFIG_DRAWER_TAB_LOADED_PATH,
  LAYOUT_DRAWER_TABS_TOOLS_ANNOTATIONS_EXPANDED,
  LAYOUT_DRAWER_TABS_TOOLS_BUFFERSELECT_EXPANDED,
  LAYOUT_DRAWER_TABS_TOOLS_DOWNLOAD_EXPANDED,
  LAYOUT_DRAWER_TABS_TOOLS_LOGIN_EXPANDED,
  LAYOUT_DRAWER_TABS_TOOLS_MEASURE_EXPANDED,
  LAYOUT_DRAWER_TABS_TOOLS_POLYGONSELECT_EXPANDED,
  LAYOUT_DRAWER_TABS_TOOLS_PROPERTYLOOKUP_EXPANDED,
  LAYOUT_DRAWER_TABS_TOOLS_SELECTGROUP_EXPANDED,
  LAYOUT_DRAWER_TABS_TOOLS_SHARE_EXPANDED,
  TOGGLE_TYPE_CLOSE,
  togglePanel
} from 'api/actions'
import * as Model from 'api/model'
import AnnotationsNew from 'drawer/tabs/layers/annotations/New'
import ToolsHeader from 'drawer/tabs/tools/panels/ToolsHeader'
import ToolsPanelDownload from 'drawer/tabs/tools/panels/ToolsPanelDownload'
import ToolsPanelLogin from 'drawer/tabs/tools/panels/ToolsPanelLogin'
import ToolsPanelMeasure from 'drawer/tabs/tools/panels/ToolsPanelMeasure'
import ToolsPanelSelect from 'drawer/tabs/tools/panels/ToolsPanelSelect'
import ToolsPanelShare from 'drawer/tabs/tools/panels/ToolsPanelShare'
import ToolsPanelUtils from 'drawer/tabs/tools/panels/ToolsPanelUtils' // This is just to load legacy (non-react) stuff after react stuff.

const styles = theme => ({
  root: {
    width: '100%',
    overflow: 'hidden',
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10
  }
})

class ToolsPanels extends React.Component {
  constructor () {
    super()
    const myEl = document.getElementById('pozi-drawer-tabs-button-tools')
    myEl.addEventListener('click', () => { Model.set('app.drawer.activetabid', 'tools') }, false)

    this.pure = {}
    this.pure.toggleExpansionPanelAnnotations = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_ANNOTATIONS_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelLogin = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_LOGIN_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelDownload = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_DOWNLOAD_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelMeasure = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_MEASURE_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelSelectGroup = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_SELECTGROUP_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelShare = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_SHARE_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelPolygonSelect = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_POLYGONSELECT_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelBufferSelect = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_BUFFERSELECT_EXPANDED).bind(this)
    this.pure.toggleExpansionPanelPropertyLookup = this.toggleExpansionPanel(LAYOUT_DRAWER_TABS_TOOLS_PROPERTYLOOKUP_EXPANDED).bind(this)
  }

  componentDidMount () {
    // If there are annotations, automatically open the draw tools accordion
    const hasAnnotations = !!Model.get('app.state.annotation', null)
    if (hasAnnotations) {
      this.pure.toggleExpansionPanelAnnotations()
      return
    }
    this.pure.toggleExpansionPanelShare()
  }

  toggleExpansionPanel (panelId) {
    // console.debug('ToolsPanels - toggleExpansionPanel', panelId)

    return function () {
      const { togglePanel } = this.props
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_ANNOTATIONS_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_ANNOTATIONS_EXPANDED, TOGGLE_TYPE_CLOSE)
      }
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_LOGIN_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_LOGIN_EXPANDED, TOGGLE_TYPE_CLOSE)
      }
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_DOWNLOAD_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_DOWNLOAD_EXPANDED, TOGGLE_TYPE_CLOSE)
      }
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_MEASURE_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_MEASURE_EXPANDED, TOGGLE_TYPE_CLOSE)
      }
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_SELECTGROUP_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_SELECTGROUP_EXPANDED, TOGGLE_TYPE_CLOSE)
      }
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_POLYGONSELECT_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_POLYGONSELECT_EXPANDED, TOGGLE_TYPE_CLOSE)
      }
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_BUFFERSELECT_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_BUFFERSELECT_EXPANDED, TOGGLE_TYPE_CLOSE)
      }
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_PROPERTYLOOKUP_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_PROPERTYLOOKUP_EXPANDED, TOGGLE_TYPE_CLOSE)
      }
      if (panelId !== LAYOUT_DRAWER_TABS_TOOLS_SHARE_EXPANDED) {
        togglePanel(LAYOUT_DRAWER_TABS_TOOLS_SHARE_EXPANDED, TOGGLE_TYPE_CLOSE)
      }

      togglePanel(panelId) // Toggle
    }
  }

  render () {
    const { classes, bToolsTabLoaded } = this.props

    // Optimisation to avoid loading panels if not on tab.
    // Note this is set indirectly by Model.set('app.drawer.activetabid', 'about')
    if (!bToolsTabLoaded) {
      return null
    }

    return (
      <div className={classes.root}>
        <ToolsHeader />
        <ToolsPanelLogin toggleExpansionPanel={this.pure.toggleExpansionPanelLogin} />
        <ToolsPanelShare toggleExpansionPanel={this.pure.toggleExpansionPanelShare} />
        <ToolsPanelDownload toggleExpansionPanel={this.pure.toggleExpansionPanelDownload} />
        <AnnotationsNew toggleExpansionPanel={this.pure.toggleExpansionPanelAnnotations} />
        <ToolsPanelMeasure toggleExpansionPanel={this.pure.toggleExpansionPanelMeasure} />
        <ToolsPanelSelect toggleExpansionPanel={this.pure.toggleExpansionPanelSelectGroup} />
        <ToolsPanelUtils />
      </div>
    )
  }
}

ToolsPanels.propTypes = {
  classes: PropTypes.object.isRequired,
  togglePanel: PropTypes.func.isRequired,
  bToolsTabLoaded: PropTypes.bool.isRequired
}

function mapStateToProps (state, ownProps) {
  const bToolsTabLoaded = get(state.config, CONFIG_DRAWER_TAB_LOADED_PATH + '.tools', false)
  return {
    bToolsTabLoaded
  }
}

const mapDispatchToProps = dispatch => {
  return {
    togglePanel: (type, toggleType) => {
      dispatch(togglePanel(type, toggleType))
    }
  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ToolsPanels)
  )
)
